module.exports = __webpack_public_path__ + "img/usd.4c3d08c6.svg";